/* DAILE v2 (dv) — NFC section (sections/dv-nfc.liquid). Port of the MVP
 * app.js NFC switcher.
 *
 * One shared demonstration stays in place; the tabs change ONLY the story in
 * the wine panel (eyebrow, title, copy, formats, note, CTA). The stage, its
 * video and its source are never touched here: no src swap, no load(), no
 * restart. (Loop playback itself is handled by dv.js.)
 *
 * Markup contract
 *   [data-dv-nfc]                experience root
 *   [data-dv-nfc-tabs]           glass tab group (gets --dv-nfc-index for the lens)
 *   button[data-dv-nfc-tab=ID]   toggle buttons, aria-pressed
 *   [data-dv-nfc-content]        aria-live region, holds the active story
 *   template[data-dv-nfc-story=ID]  server-rendered story for each tab
 *
 * Theme editor: selecting a scenario block activates its tab.
 */
(() => {
  'use strict';

  const init = (root) => {
    const experiences = window.DV.queryAll(root, '[data-dv-nfc]');
    if (!experiences.length) return undefined;

    const activators = new Map(); // tab button -> activate()
    const cleanups = [];

    experiences.forEach((experience) => {
      const tabs = [...experience.querySelectorAll('[data-dv-nfc-tab]')];
      const region = experience.querySelector('[data-dv-nfc-content]');
      const group = experience.querySelector('[data-dv-nfc-tabs]');
      if (!tabs.length || !region) return;

      const stories = new Map();
      experience.querySelectorAll('template[data-dv-nfc-story]').forEach((template) => {
        stories.set(template.getAttribute('data-dv-nfc-story'), template);
      });

      const activate = (tab) => {
        if (!tab || tab.getAttribute('aria-pressed') === 'true') return;
        const id = tab.getAttribute('data-dv-nfc-tab');
        const template = stories.get(id);
        if (!template) return;
        tabs.forEach((other) => other.setAttribute('aria-pressed', String(other === tab)));
        if (group) group.style.setProperty('--dv-nfc-index', String(tabs.indexOf(tab)));
        experience.setAttribute('data-dv-nfc-active', id);
        // Only the explanation changes; aria-live + aria-atomic announce it.
        region.replaceChildren(template.content.cloneNode(true));
      };

      const onClick = (event) => activate(event.currentTarget);
      tabs.forEach((tab) => {
        tab.addEventListener('click', onClick);
        activators.set(tab, activate);
      });

      cleanups.push(() => tabs.forEach((tab) => tab.removeEventListener('click', onClick)));
    });

    return {
      destroy() {
        cleanups.forEach((fn) => fn());
        activators.clear();
      },
      onBlockSelect(block) {
        const tab = block && block.closest ? block.closest('[data-dv-nfc-tab]') : null;
        const activate = tab ? activators.get(tab) : null;
        if (activate) activate(tab);
      },
    };
  };

  const boot = () => window.DV.register('dv-nfc', init);

  if (window.DV && typeof window.DV.register === 'function') boot();
  else document.addEventListener('dv:ready', boot, { once: true });
})();
